import { formatResourcePath } from 'src/utils/regex';
import { GeneralASError } from 'src/registry/types/axios';
import { MutationConfig } from 'src/lib/react-query';
import { useMutation } from '@tanstack/react-query';
import axios from 'src/lib/axios';
import { ServicePlanItem } from 'src/features/servicePlanItems/utils/types';
import { ServicePlanItemFormSchemaValues } from 'src/features/servicePlanItems/utils/formSchema';

const RESOURCE = '/subscriptions/service-plan-item/';

type MutationFnType = typeof mutationFn;
const mutationFn = (data: ServicePlanItemFormSchemaValues): Promise<ServicePlanItem> => {
    return axios.post(formatResourcePath(RESOURCE), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralASError>) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useCreateServicePlanItem };
